import { Component, Input, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { FertilizerTypeEnum } from 'src/app/crop-aid/crop-aid.model';
import { FertilizerDataByType, FertilizerType } from 'src/app/fertilizers/models/fertilizer.model';

@Component({
  selector: 'app-fertilizers-overview',
  templateUrl: './fertilizers-overview.component.html',
  styleUrls: ['./fertilizers-overview.component.scss'],
  standalone: false,
})
export class FertilizersOverviewComponent {
  private readonly localeService = inject(LocaleService);

  @Input() fertilizerDataByType: FertilizerDataByType[] = [];

  getFertilizerTypeName = (fertilizerType: FertilizerType): string => {
    let fertilizerTypeName = '';
    switch (fertilizerType) {
      case FertilizerType.Delivered:
        fertilizerTypeName = 'isDelivered';
        break;
      case FertilizerType.NotDelivered:
        fertilizerTypeName = 'isNotDelivered';
        break;
      case FertilizerType.InitialStock:
        fertilizerTypeName = 'initialStock';
        break;
      case FertilizerType.ClosingStock:
        fertilizerTypeName = 'closingStock';
        break;
      case FertilizerType.Dispatched:
        fertilizerTypeName = 'dispatched';
        break;
      default:
        fertilizerTypeName = 'unknown';
        break;
    }
    return this.localeService.translate(fertilizerTypeName);
  };

  isAnimal = (cropAidFertilizerType: FertilizerTypeEnum): boolean =>
    cropAidFertilizerType === FertilizerTypeEnum.Animal;
}
